import { useEffect, useState } from "react";
import { Container, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";

function Theming() {
  const theme = useTheme();
  // List of all the available typography styles in Material-UI
  const typographyStyles = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "button",
    "caption",
    "overline",
  ];

  const [functionNames, setFunctionNames] = useState([]);

  const loadFunctions = async () => {
    try {
      const module = await import("../../components/icons/bcp/BCPIcons.js");
      const functions = Object.keys(module)
        .filter((key) => typeof module[key] === "function")
        .sort()
        .map((key) => {
          return {
            key: key,
            Icon: module[key],
          };
        });
      setFunctionNames(functions);
    } catch (error) {
      console.error("Error loading functions:", error);
    }
  };

  useEffect(() => {
    loadFunctions();
  }, []);

  return (
    <Container
      sx={{
        pt: 2,
        pb: 2,
      }}
    >
      <Grid
        item
        xs={12}
        sx={{ mb: 1, borderBottom: 2, borderColor: "divider" }}
      >
        <Typography variant="h1">Colors</Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "primary.light",
              color: "primary.contrastText",
            }}
          >
            primary.light {theme?.palette?.primary?.light} primary.contrastText{" "}
            {theme?.palette?.primary?.contrastText}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "primary.main",
              color: "primary.contrastText",
            }}
          >
            primary.main {theme?.palette?.primary?.main} primary.contrastText{" "}
            {theme?.palette?.primary?.contrastText}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "primary.dark",
              color: "primary.contrastText",
            }}
          >
            primary.dark {theme?.palette?.primary?.dark} primary.contrastText{" "}
            {theme?.palette?.primary?.contrastText}
          </Grid>
        </Grid>

        <Grid container>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "secondary.light",
              color: "secondary.contrastText",
            }}
          >
            secondary.light {theme?.palette?.secondary?.light}{" "}
            secondary.contrastText {theme?.palette?.secondary?.contrastText}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "secondary.main",
              color: "secondary.contrastText",
            }}
          >
            secondary.main {theme?.palette?.secondary?.main}{" "}
            secondary.contrastText {theme?.palette?.secondary?.contrastText}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "secondary.dark",
              color: "secondary.contrastText",
            }}
          >
            secondary.dark {theme?.palette?.secondary?.dark}{" "}
            secondary.contrastText {theme?.palette?.secondary?.contrastText}
          </Grid>
        </Grid>

        <Grid container>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "error.light",
              color: "error.contrastText",
            }}
          >
            error.light {theme?.palette?.error.light} error.contrastText{" "}
            {theme?.palette?.error.contrastText}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "error.main",
              color: "error.contrastText",
            }}
          >
            error.main {theme?.palette?.error.main} error.contrastText{" "}
            {theme?.palette?.error.contrastText}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "error.dark",
              color: "error.contrastText",
            }}
          >
            error.dark {theme?.palette?.error.dark} error.contrastText{" "}
            {theme?.palette?.error.contrastText}
          </Grid>
        </Grid>

        <Grid container>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "info.light",
              color: "info.contrastText",
            }}
          >
            info.light {theme?.palette?.info.light} info.contrastText{" "}
            {theme?.palette?.info.contrastText}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "info.main",
              color: "info.contrastText",
            }}
          >
            info.main {theme?.palette?.info.main} info.contrastText{" "}
            {theme?.palette?.info.contrastText}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "info.dark",
              color: "info.contrastText",
            }}
          >
            info.dark {theme?.palette?.info.dark} info.contrastText{" "}
            {theme?.palette?.info.contrastText}
          </Grid>
        </Grid>

        <Grid container>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "success.light",
              color: "success.contrastText",
            }}
          >
            success.light {theme?.palette?.success.light} success.contrastText{" "}
            {theme?.palette?.success.contrastText}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "success.main",
              color: "success.contrastText",
            }}
          >
            success.main {theme?.palette?.success.main} success.contrastText{" "}
            {theme?.palette?.success.contrastText}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "success.dark",
              color: "success.contrastText",
            }}
          >
            success.dark {theme?.palette?.success.dark} success.contrastText{" "}
            {theme?.palette?.success.contrastText}
          </Grid>
        </Grid>

        <Grid container>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "warning.light",
              color: "warning.contrastText",
            }}
          >
            warning.light {theme?.palette?.warning.light} warning.contrastText{" "}
            {theme?.palette?.warning.contrastText}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "warning.main",
              color: "warning.contrastText",
            }}
          >
            warning.main {theme?.palette?.warning.main} warning.contrastText{" "}
            {theme?.palette?.warning.contrastText}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "warning.dark",
              color: "warning.contrastText",
            }}
          >
            warning.dark {theme?.palette?.warning.dark} warning.contrastText{" "}
            {theme?.palette?.warning.contrastText}
          </Grid>
        </Grid>

        <Grid container>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "background.paper",
              color: "text.primary",
            }}
          >
            text.primary {theme?.palette?.text?.primary}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "background.paper",
              color: "text.secondary",
            }}
          >
            text.secondary {theme?.palette?.text?.secondary}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "background.paper",
              color: "text.disabled",
            }}
          >
            text.disabled {theme?.palette?.text?.disabled}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "background.paper",
              color: "text.error",
            }}
          >
            text.error {theme?.palette?.text?.error}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "background.paper",
              color: "text.message",
            }}
          >
            text.message {theme?.palette?.text?.message}
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              backgroundColor: "background.paper",
              color: "link.main",
            }}
          >
            link {theme?.palette?.link.main}
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          mt: 2,
          mb: 1,
          borderBottom: 2,
          borderColor: "divider",
        }}
      >
        <Typography variant="h1">Typography</Typography>
      </Grid>
      {typographyStyles.map((style) => (
        <Grid item xs={12} key={style}>
          <Typography variant={style} gutterBottom>
            {style.toUpperCase()} - Lorem ipsum dolor sit amet
          </Typography>
        </Grid>
      ))}

      <Grid
        item
        xs={12}
        sx={{
          mt: 2,
          mb: 1,
          borderBottom: 2,
          borderColor: "divider",
        }}
      >
        <Typography variant="h1">Iconography</Typography>
      </Grid>

      {functionNames?.length > 0 ? (
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {functionNames.map((f) => {
              const { Icon, key } = f;
              return (
                <Grid key={key} item xs={4} sm={3} textAlign="center">
                  <Icon themepage />
                  <Typography variant="subtitle1">{key.slice(3)}</Typography>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </Container>
  );
}

export default Theming;
